import React from "react";

function AddarrowIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="22"
      fill="none"
      viewBox="0 0 18 22"
    >
      <path
        stroke="#4F4F4F"
        strokeDasharray="2 2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M1 1h11.676v20m0 0l-4.757-3.684M12.676 21L17 17.316"
      ></path>
    </svg>
  );
}

export default AddarrowIcon;
